/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Description_LabelInputs */

const en_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const fr_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

const it_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione`)
};

const ru_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание`)
};

const es_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

const zh_cn2_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述`)
};

const ja_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明`)
};

const hi_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण`)
};

const pt_pt2_knp_guide_description_label = /** @type {(inputs: Knp_Guide_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Knp_Guide_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_description_label = /** @type {((inputs?: Knp_Guide_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_description_label(inputs)
	if (locale === "de") return de_knp_guide_description_label(inputs)
	if (locale === "it") return it_knp_guide_description_label(inputs)
	if (locale === "ru") return ru_knp_guide_description_label(inputs)
	if (locale === "es") return es_knp_guide_description_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_description_label(inputs)
	if (locale === "ja") return ja_knp_guide_description_label(inputs)
	if (locale === "hi") return hi_knp_guide_description_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_description_label(inputs)
	return en_knp_guide_description_label(inputs)
});